import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    dialogOpen: false,
    micMissing: false,
    localNetworkMissing: false,
};

const streamPermissionsSlice = createSlice({
    name: 'streamPermissions',
    initialState,
    reducers: {
        reportMicDenied(state) {
            // Open the dialog only on a fresh denial (a transition into missing). Re-reporting an
            // already-missing permission must not reopen a dialog the user dismissed with "Got it".
            if (!state.micMissing) state.dialogOpen = true;
            state.micMissing = true;
        },
        reportLocalNetworkDenied(state) {
            if (!state.localNetworkMissing) state.dialogOpen = true;
            state.localNetworkMissing = true;
        },
        clearMicDenied(state) {
            state.micMissing = false;
            if (!state.localNetworkMissing) state.dialogOpen = false;
        },
        clearLocalNetworkDenied(state) {
            state.localNetworkMissing = false;
            if (!state.micMissing) state.dialogOpen = false;
        },
        closeDialog(state) {
            state.dialogOpen = false;
        },
    },
});

export const streamPermissionsActions = streamPermissionsSlice.actions;
export const streamPermissionsReducer = streamPermissionsSlice.reducer;
